import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Button, Result } from 'antd'
import { CRow, CCard, CCardHeader, CCol } from '@coreui/react'

const ErrorPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [seconds, setSeconds] = useState(5)

  // On récupère le type d'erreur passé via state
  const errorType = location.state?.type || '404'

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1)
    }, 1000)

    const timeout = setTimeout(() => {
      navigate('/')
    }, 5000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [navigate])

  const isUnauthorized = errorType === '403'

  return (
    <CRow>
      <CCard className="mb-4">
        <CCardHeader>
          <CCol xs={12}>
            <hr />
            <Result
              status={isUnauthorized ? '403' : '404'}
              title={isUnauthorized ? '403' : '404'}
              subTitle={
                isUnauthorized
                  ? "Accès refusé — Vous n'avez pas les droits nécessaires pour accéder à cette page."
                  : "Désolé, cette page est introuvable."
              }
              extra={
                <div>
                  <Button type="primary" onClick={() => navigate('/')}>
                    Retour à l'accueil
                  </Button>
                  <br />
                  <span
                    style={{
                      marginLeft: '10px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    }}
                  >
                    <p>Redirection automatique dans {seconds}...</p>
                  </span>
                </div>
              }
            />
            <hr />
          </CCol>
        </CCardHeader>
      </CCard>
    </CRow>
  )
}

export default ErrorPage
